import axios from 'axios'
import { errorHandler } from '@/api/error-handler'

const BASE_URL = '/news'

export default {
  lastNews: () => axios.get(`${BASE_URL}/last_news`)
    .then(response => response.data)
    .catch(errorHandler),

  list: (params) => axios.get(`${BASE_URL}`, { params: params })
    .then(response => response.data)
    .catch(errorHandler),

  retrieve: (slug) => axios.get(`${BASE_URL}/${slug}`)
    .then(response => response.data)
    .catch(errorHandler),

  listTags: () => axios.get(`${BASE_URL}/list_tags`)
    .then(response => response.data)
    .catch(errorHandler)
}
